import app from '../../http/firebase';

const chatUsers = app.database().ref().child('chat_users');
const conversations = app.database().ref().child('conversations');


export const getChatUsers = () => {
    return dispatch => {
        chatUsers.on('value', snapshot => {
            dispatch({
                type: 'GET_CHAT_USERS',
                payload: snapshot.val()
            });
        });
    };
};

export const newMessageListener = () => {
    let index = 0;
    return dispatch => {
        conversations.once('value', snp => {
            const datas = snp.val();
            const messagesid = Object.keys(datas).map(key => Object.keys(datas[key]));
            const messagesLength = messagesid.reduce((accumulator, currentValue) => {
                   return accumulator + currentValue.length;
                }, 0);
            conversations.on('child_added', snapshot => {
                const key = snapshot.key;
                app.database().ref().child(`conversations/${key}`).on("child_added", snap => {
                    index++;
                    if(index > messagesLength) {
                        chatUsers.once('value', s => {
                            let userData = null;
                            const val = s.val();
                            for (const objKey of Object.keys(val)) {
                                if (key === val[objKey].conversation) {
                                    userData = val[objKey];
                                    break;
                                }
                            }
                            dispatch({
                                type: "NEW_MESSAGE",
                                payload: {userData, message: snap.val()}
                            });
                        });

                    }
                });

            });
        });
    };
};


export const getConversation = (id) => {
    return dispatch => {
        app.database().ref().child(`conversations/${id}`).on('value', snapshot => {
            dispatch({
                type: 'GET_CONVERSATION',
                payload: snapshot.val()
            });
        });
    };
};


export const sendMessage = (id, data, uuid, currentUserConversationId) => {
    return dispatch => {
        const message = app.database().ref().child(`conversations/${id}/${uuid}`);
        message.set(data);
        app.database().ref().child(`chat_users/${currentUserConversationId}/last_message_timestamp`).set(data.timestamp);
    };
};


export const changeChatStatus = (id) => {
    return dispatch => {
        app.database().ref(`chat_users/${id}/status`).set("closed");
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/livechat.js